const roles = {
  /* BLOCK TEMPLATE */
  TEMPLATE_INDEX: 'pageTemplate.index',
  TEMPLATE_UPDATE: 'pageTemplate.update',
  /* PAGE */
  PAGE_INDEX: 'page.index',
  PAGE_STORE: 'page.store',
  PAGE_UPDATE: 'page.update',
  PAGE_DESTROY: 'page.destroy',
  PAGE_APPROVED: 'page.approved',

  PAGE_COMMENT_INDEX: 'pageComment.index',
  PAGE_COMMENT_STORE: 'pageComment.store',
  /* MEDIA */
  FOLDER_STORE: 'mediaFolder.store',
  FOLDER_UPDATE: 'mediaFolder.update',
  FOLDER_DESTROY: 'mediaFolder.destroy',
  FOLDER_VIEWALL: 'mediaFolder.allFolders',
  FOLDER_GETITEMS: 'mediaFolder.getItemsByFolder',

  FILE_UPDATE: 'mediaFile.update',
  FILE_DESTROY: 'mediaFile.destroy',
  FILE_UPLOAD: 'mediaFile.uploadFile',

  TRASH_INDEX: 'mediaTrash.index',
  TRASH_RESTORE: 'mediaTrash.restore',
  TRASH_FORCEDELETE: 'mediaTrash.forceDelete',
  TRASH_EMPTY: 'mediaTrash.empty',
  /* MENU */
  MENU_INDEX: 'menu.index',
  MENU_STORE: 'menu.store',
  MENU_DESTROY: 'menu.destroy',
  MENU_MANAGE: 'menu.manage',
  /* NEWS */
  NEWS_INDEX: 'news.index',
  NEWS_STORE: 'news.store',
  NEWS_UPDATE: 'news.update',
  NEWS_DESTROY: 'news.destroy',
  NEWS_APPROVED: 'news.approved',

  NEWS_COMMENT_INDEX: 'newsComment.index',
  NEWS_COMMENT_STORE: 'newsComment.store',
  /* NEWS CATEGORY */
  NEWS_CATE_INDEX: 'newsCategory.index',
  NEWS_CATE_STORE: 'newsCategory.store',
  NEWS_CATE_UPDATE: 'newsCategory.update',
  NEWS_CATE_DESTROY: 'newsCategory.destroy',
  NEWS_CATE_APPROVED: 'newsCategory.approved',

  NEWS_CATE_COMMENT_INDEX: 'newsCategoryComment.index',
  NEWS_CATE_COMMENT_STORE: 'newsCategoryComment.store',
  /* BANNER */
  BANNER_INDEX: 'banner.index',
  BANNER_STORE: 'banner.store',
  BANNER_UPDATE: 'banner.update',
  BANNER_DESTROY: 'banner.destroy',

  BANNER_COMMENT_INDEX: 'bannerComment.index',
  BANNER_COMMENT_STORE: 'bannerComment.store',
  /* SYSTEM */
  SYSTEM_INDEX: 'configGeneral.index',
  SYSTEM_STORE: 'configGeneral.store',
  SEO_GENERAL_INDEX: 'seoGeneral.index',
  SEO_GENERAL_STORE: 'seoGeneral.store',
  SYSTEM_LOCALE_INDEX: 'configLocale.index',
  SYSTEM_LOCALE_STORE: 'configLocale.store',
  /* HEADER */
  CONFIG_HEADER_INDEX: 'configHeader.index',
  CONFIG_HEADER_STORE: 'configHeader.store',
  /* FOOTER */
  CONFIG_FOOTER_INDEX: 'configFooter.index',
  CONFIG_FOOTER_STORE: 'configFooter.store',
  /* FE TRANSLATION  */
  FE_TRANSLATION_INDEX: 'feTranslation.index',
  FE_TRANSLATION_STORE: 'feTranslation.store',
  FE_TRANSLATION_UPDATE: 'feTranslation.update',
  FE_TRANSLATION_DESTROY: 'feTranslation.destroy',
  FE_TRANSLATION_EXPORT: 'feTranslation.export',
  FE_TRANSLATION_IMPORT: 'feTranslation.import',
  /* CMS TRANSLATION  */
  CMS_TRANSLATION_INDEX: 'cmsTranslation.index',
  CMS_TRANSLATION_STORE: 'cmsTranslation.store',
  CMS_TRANSLATION_UPDATE: 'cmsTranslation.update',
  CMS_TRANSLATION_DESTROY: 'cmsTranslation.destroy',
  CMS_TRANSLATION_EXPORT: 'cmsTranslation.export',
  CMS_TRANSLATION_IMPORT: 'cmsTranslation.import',
  /* REDIRECT */
  REDIRECT_INDEX: 'redirect.index',
  REDIRECT_STORE: 'redirect.store',
  REDIRECT_UPDATE: 'redirect.update',
  REDIRECT_DESTROY: 'redirect.destroy',
  REDIRECT_IMPORT: 'redirect.import',
  /* FAQ */
  FAQ_INDEX: 'faq.index',
  FAQ_STORE: 'faq.store',
  FAQ_UPDATE: 'faq.update',
  FAQ_DESTROY: 'faq.destroy',
  FAQ_APPROVED: 'faq.approved',

  FAQ_COMMENT_INDEX: 'faqComment.index',
  FAQ_COMMENT_STORE: 'faqComment.store',
  /* FAQ CATEGORY */
  FAQ_CATEGORY_INDEX: 'faqCategory.index',
  FAQ_CATEGORY_STORE: 'faqCategory.store',
  FAQ_CATEGORY_UPDATE: 'faqCategory.update',
  FAQ_CATEGORY_DESTROY: 'faqCategory.destroy',
  FAQ_CATEGORY_APPROVED: 'faqCategory.approved',

  FAQ_CATEGORY_COMMENT_INDEX: 'faqCategoryComment.index',
  FAQ_CATEGORY_COMMENT_STORE: 'faqCategoryComment.store',
  /* ERROR PAGES */
  ERROR_PAGE_400: 'configErrorsPage.error400',
  ERROR_PAGE_403: 'configErrorsPage.error403',
  ERROR_PAGE_404: 'configErrorsPage.error404',
  ERROR_PAGE_429: 'configErrorsPage.error429',
  ERROR_PAGE_500: 'configErrorsPage.error500',
  /* CONTACT */
  CONTACT_INDEX: 'contact.index',
  CONTACT_UPDATE: 'contact.update',
  CONTACT_DESTROY: 'contact.destroy',
  /* CONTACT PROBLEM */
  CONTACT_PROBLEM_INDEX: 'contactProblem.index',
  CONTACT_PROBLEM_STORE: 'contactProblem.store',
  CONTACT_PROBLEM_UPDATE: 'contactProblem.update',
  CONTACT_PROBLEM_DESTROY: 'contactProblem.destroy',
  CONTACT_PROBLEM_APPROVED: 'contactProblem.approved',

  CONTACT_PROBLEM_COMMENT_INDEX: 'contactProblemComment.index',
  CONTACT_PROBLEM_COMMENT_STORE: 'contactProblemComment.store',
  /* EMAIL TEMPLATE */
  EMAIL_TEMPLATE_INDEX: 'emailTemplate.index',
  EMAIL_TEMPLATE_UPDATE: 'emailTemplate.update',

  /* FORM */
  FORM_INDEX: 'formManagement.index',
  FORM_STORE: 'formManagement.store',
  FORM_UPDATE: 'formManagement.update',
  FORM_DESTROY: 'formManagement.destroy',

  SUBMIT_FROM: 'submitForm.index',
  SUBMIT_FROM_LIST_BY_FORM: 'submitForm.listByForm',
  SUBMIT_FROM_UPDATE: 'submitForm.update',

  /* ActivityLogs */
  ACTIVITYLOG_INDEX: 'activityLog.index',

  /* StaticBlocks */
  STATIC_BLOCK_INDEX: 'staticBlock.index',
  STATIC_BLOCK_STORE: 'staticBlock.store',
  STATIC_BLOCK_UPDATE: 'staticBlock.update',
  STATIC_BLOCK_DESTROY: 'staticBlock.destroy',

  /* Project */
  PROJECT_INDEX: 'project.index',
  PROJECT_STORE: 'project.store',
  PROJECT_UPDATE: 'project.update',
  PROJECT_DESTROY: 'project.destroy',
  PROJECT_IMPORT_STAFF: 'project.importStaff',
  PROJECT_APPROVED_STAFF: 'project.approveStaff',
  PROJECT_DECLINE_STAFF: 'project.declineStaff',
  STORE_PAYROLL_PROJECT: 'project.storePayrollProject',
  SHOW_PAYROLL_PROJECT: 'project.showPayrollProject',
  PROJECT_UPDATE_LINK: 'project.updateLinkOpen',

  /* Employee */
  EMPLOYEE_INDEX: 'staff.index',
  EMPLOYEE_STORE: 'staff.store',
  EMPLOYEE_DESTROY: 'staff.destroy',
  EMPLOYEE_UPDATE: 'staff.update',
  EMPLOYEE_OCR: 'staff.ocr',
  EMPLOYEE_IMPORT: 'staff.import',
  EMPLOYEE_FIND_BY_ID_CARD_NUMBER: 'staff.findByIdCardNumber',
  EMPLOYEE_DELETE_BANK: 'staff.deleteBank',
  PROJECT_PRINT_CONTRACT: 'staff.printContract',

  /* Bank */
  BANK_INDEX: 'bank.index',
  BANK_STORE: 'bank.store',
  BANK_DESTROY: 'bank.destroy',
  BANK_UPDATE: 'bank.update',

  PROVINCE_INDEX: 'province.index',

  /* SalaryCalculate */
  // SALARY_CALCULATE_INDEX: 'salaryCalculate.index',

  /* Employee Assign */
  EMPLOYEE_ASSIGN_INDEX: 'staffAssign.index',
  EMPLOYEE_ASSIGN_STORE: 'staffAssign.store',
  EMPLOYEE_ASSIGN_DESTROY: 'staffAssign.destroy',
  EMPLOYEE_ASSIGN_UPDATE: 'staffAssign.update',
  EMPLOYEE_ASSIGN_OCR: 'staffAssign.ocr',
  EMPLOYEE_ASSIGN_IMPORT: 'staffAssign.import',

  /* Approve salary */
  PAYROLL_PERIOD_INDEX: 'payrollPeriod.index', // Kỳ chấm công
  PAYROLL_PERIOD_UPDATE: 'payrollPeriod.update', // Kỳ chấm công
  PAYROLL_PERIOD_STORE: 'payrollPeriod.store',
  PAYROLL_PERIOD_DESTROY: 'payrollPeriod.destroy',
  APPROVE_SALARY_APPROVE_INDEX: 'payrollPeriod.approveIndex',
  APPROVE_SALARY_APPROVE_SHOW: 'payrollPeriod.approveShow',
  SUP_APPROVE_SALARY: 'payrollPeriod.approvePeriod',
  AC_APPROVE_SALARY: 'payrollPeriod.updateACApprove',
  OP_APPROVE_SALARY: 'payrollPeriod.updateOPApprove',
  KT_APPROVE_SALARY: 'payrollPeriod.updateKTApprove',
  // EXPORT_SALARY_REPORT: 'projectPayrollPeriod.export',
  IMPORT_SALARY_REPORT: 'projectPayrollPeriod.import',
  APPROVE_DEPARTMENT_INDEX: 'payrollPeriod.approveByDepartmentIndex',
  APPROVE_DEPARTMENT_SHOW: 'payrollPeriod.approveByDeparmentShow',
  PAYROLL_PERIOD_APPROVE_LOG: 'payrollPeriodApproveLog.index',
  // PAYROLL_PERIOD_APPROVE_LOG_SHOW: 'payrollPeriodApproveLog.show',
  PAYROLL_PERIOD_STAFF_JOIN_IN_PAYROLL: 'payrollPeriod.getStaffJoinInPayroll',
  PAYROLL_PERIOD_APPROVED: 'payrollPeriod.payrollPeriodApproved',
  PAYROLL_PERIOD_COPY: 'payrollPeriod.copyPayrollPeriod',

  /* Salary record */
  SALARY_RECORD_APRROVE_INDEX: 'salaryRecord.approveIndex',
  SALARY_RECORD_APRROVE_SHOW: 'salaryRecord.approveShow',

  SALARY_RECORD_INDEX: 'salaryRecord.index',
  SALARY_RECORD_STORE: 'salaryRecord.store',
  SALARY_RECORD_NOTE_SUPPORT_ANOTHER: 'salaryRecord.addNoteSupportAnother',
  // SALARY_RECORD_UPDATE: 'salaryRecord.update',
  // SALARY_RECORD_DESTROY: 'salaryRecord.destroy',
  SALARY_CATEGORY_INDEX: 'salaryCategory.index',
  SALARY_CATEGORY_STORE: 'salaryCategory.store',

  /* Attendance record */
  ATTENDANCE_RECORD_INDEX: 'attendanceRecord.index',
  ATTENDANCE_RECORD_STORE: 'attendanceRecord.store',
  ATTENDANCE_RECORD_UPDATE: 'attendanceRecord.update',
  ATTENDANCE_RECORD_DESTROY: 'attendanceRecord.destroy',
  ATTENDANCE_RECORD_EXPORT_INDEX: 'attendanceRecord.exportAttendanceRecord',
  ATTENDANCE_RECORD_IMPORT: 'attendanceRecord.import',
  ATTENDANCE_RECORD_UPDATE_NOTE: 'attendanceRecord.updateNote',

  /* Employee fulltime */
  EMPLOYEE_FULLTIME_INDEX: 'staffFullTime.index',
  EMPLOYEE_FULLTIME_STORE: 'staffFullTime.store',
  EMPLOYEE_FULLTIME_DESTROY: 'staffFullTime.destroy',
  EMPLOYEE_FULLTIME_UPDATE: 'staffFullTime.update',

  /* Position */
  POSITION_INDEX: 'position.index',
  POSITION_STORE: 'position.store',
  POSITION_DESTROY: 'position.destroy',
  POSITION_UPDATE: 'position.update',

  /* Export */
  ANNUAL_REPORT: 'export.anualReport',
  ATTENDANCE_RECORD: 'export.attendanceRecordExport',
  MONTHLY_REPORT: 'export.monthlyReport',
  PAYROLL_SUMMARY: 'export.payrollSummary',
  SALARY_RECORD: 'export.salaryRecordExport',
  TRANSFER_OUT_MAIN: 'export.transferOutOfMain',
  TRANSFER_IN_MAIN: 'export.transferInMain',
  EXPORT_INDEX: 'export.index',
  EXPORT_STAFF_ASSIGN: 'export.staffAssign',
  EXPORT_STAFF: 'export.staff'
};

export default roles;

export const getPermission = (rolePermission: string[], key: string): boolean => {
  if (rolePermission.includes('*') || rolePermission.includes(key)) return true;
  return false;
};
